import { PageType } from "@product/scmp-sdk";

export const pathname = "/plus/agenda";

export const page = {
  route(
    query: QueryParameters<{
      articleId?: string;
      entityId?: string;
      nodeId?: string;
      startDate?: string;
    }>,
  ) {
    return { pathname, query: { ...query, pageType: PageType.Plus } };
  },
};
